var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fact"
  }, [(_vm.showingForm && _vm.editable) ? _c('form', [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "breakfast-foods"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("activerecord.attributes.company.breakfast_food")))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('CmSelect', {
    staticClass: "breakfast-foods__select",
    attrs: {
      "name": "breakfast-foods",
      "options": _vm.options,
      "label": _vm.I18n.t('choose_breakfast_food')
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-action-row"
  }, [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveForm($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cancel-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('cancel')))])])]) : [_c('div', {
    staticClass: "fact__header"
  }, [_vm._v(_vm._s(_vm.I18n.t("activerecord.attributes.company.breakfast_food")))]), _vm._v(" "), _c('div', {
    staticClass: "fact__text"
  }, [_c('span', [_vm._v(_vm._s(_vm.value ? _vm.I18n.t('breakfast_foods.' + _vm.value) : _vm.I18n.t('choose_breakfast_food')))]), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("compose")]) : _vm._e()])]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e0ad71a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/breakfast-food.vue
// module id = null
// module chunks = 